module.exports = __webpack_public_path__ + "static/media/Seifenspender.0da62b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Seifenspender.png
// module id = 139
// module chunks = 0